import React, { useContext, useState, useEffect } from "react";
import plus from "../../Assets/Images/plus.png";
import minus from "../../Assets/Images/minus.png";
import zero from "../../Assets/Images/zero.png";
import three from "../../Assets/Images/three.png";
import CoinIcon from "../../Assets/Images/coin-icon1.png";
import { TokenContext } from "../../Context/TokenContext";
import { toast } from "react-toastify";
import AuthContext from "../../Context/AuthContext";
import { buyTokensStripe, fetchTokens, fetchSavedCards } from "../../api";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import PurchaseHistory from "../PurchaseHistory/PurchaseHistory";
import Disclaimer from "../TokenCheckoutPage/Disclaimer";
import AddNewCard from "../AddNewCard/AddNewCard";
import CircularProgress from "@mui/material/CircularProgress";

export default function TokenDashboard({ heading, data, clientId, requiredTokens }) {
  const tokenCtx = useContext(TokenContext);
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const newParams = new URLSearchParams(searchParams);
  const [cardInfo, setCardInfo] = useState({
    cardNumber: "",
    expMonth: "",
    expYear: "",
    cvv: "***",
  });

  const [useSavedCard, setUseSavedCard] = useState({ cardNumber: true, expiry: true, cvv: true });
  const [hasSavedCard, setHasSavedCard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  console.log('cardInfo', cardInfo)
  console.log('hasSavedCard', hasSavedCard)
  console.log('useSavedCard', useSavedCard)

  const isBack = searchParams.get("isBack") === "true"
  const [activeTab, setActiveTab] = useState("Buy Tokens");

  const defaultTokens = requiredTokens || 2;
  const formattedDefault = defaultTokens.toString().padStart(3, "0").split("").map(Number);
  console.log('formattedDefault', formattedDefault)
  const [tokenValue, setTokenValue] = useState(formattedDefault);

  // Add a new state for direct input
  const [directInput, setDirectInput] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  // Handle direct input change
  const handleDirectInputChange = (e) => {
    const value = e.target.value;
    // Only allow numeric input and max length of 3
    if (/^\d*$/.test(value) && value.length <= 3) {
      setDirectInput(value);
    }

    newParams.delete("isBack");
    setSearchParams(newParams);
  };

  // When direct input is submitted (blur or enter key)
  const handleInputSubmit = () => {
    // Convert to number and validate between 1-999
    let numValue = parseInt(directInput || "0", 10);

    // Ensure value is at least 1 and at most 999
    numValue = Math.min(Math.max(numValue, 1), 999);

    // Convert number to array of digits with leading zeros
    const strValue = numValue.toString().padStart(3, '0');
    setTokenValue([
      parseInt(strValue[0], 10),
      parseInt(strValue[1], 10),
      parseInt(strValue[2], 10)
    ]);

    setIsEditing(false);
  };

  // Handle key press events (Enter to submit)
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleInputSubmit();
    }
  };

  // Start editing
  const startEditing = () => {
    // Convert current tokenValue to string for editing
    const currentValue = parseInt(tokenValue.join(""), 10);
    setDirectInput(currentValue.toString());
    setIsEditing(true);
  };

  const increment = () => {
    let newValue = [...tokenValue];
    // Increment the last digit
    if (newValue[2] < 9) {
      newValue[2]++;
    } else {
      newValue[2] = 0;
      if (newValue[1] < 9) {
        newValue[1]++;
      } else {
        newValue[1] = 0;
        if (newValue[0] < 9) {
          newValue[0]++;
        } else {
          newValue[0] = 9;
          newValue[1] = 9;
          newValue[2] = 9;
        }
      }
    }

    // Make sure value doesn't exceed 999
    const totalValue = parseInt(newValue.join(""), 10);
    if (totalValue <= 999) {
      setTokenValue(newValue);
      tokenCtx?.setTokenCount(newValue)

      newParams.delete("isBack");
      setSearchParams(newParams);
    }
  };

  const decrement = () => {
    let newValue = [...tokenValue];

    // Get current total
    const currentTotal = parseInt(newValue.join(""), 10);

    // Don't go below 1
    if (currentTotal <= 1) {
      setTokenValue([0, 0, 1]);
      return;
    }

    // Decrement the last digit
    if (newValue[2] > 0) {
      newValue[2]--;
    } else {
      newValue[2] = 9;
      if (newValue[1] > 0) {
        newValue[1]--;
      } else {
        newValue[1] = 9;
        if (newValue[0] > 0) {
          newValue[0]--;
        } else {
          newValue[0] = 0;
        }
      }
    }
    setTokenValue(newValue);
    tokenCtx?.setTokenCount(newValue)

    newParams.delete("isBack");
    setSearchParams(newParams);
  };

  const totalTokens = parseInt(tokenValue.join(""), 10);

  let pricePerToken = 50;
  if (totalTokens >= 21 && totalTokens <= 50) {
    pricePerToken = 45;
  }
  else if (totalTokens > 50) {
    pricePerToken = 40;
  }

  const getDiscountedAmount = () => {
    const amount = totalTokens > 20 && totalTokens <= 50 ? totalTokens * 45 : totalTokens > 50 ? totalTokens * 40 : totalTokens * 50;
    return amount.toString();
  }

  // console.log( 'authCtx?.customerId', authCtx?.customerId)
  // console.log( 'authCtx?.orgId', authCtx?.orgId)
  // console.log( 'authCtx?.userId', authCtx?.userId)
  // console.log( 'tokenCtx?.selectedToken', tokenCtx?.selectedToken)
  // console.log("tokenValue",tokenValue)

  const handleCheckoutClick = () => {
    if (!hasSavedCard) {
      setActiveTab("Payment Method");
      toast.info("Please add a card before proceeding to checkout.");
      return;
    }

    navigate(`/token-checkout?clientId=${clientId}`, {
      state: {
        tokenValue,
        customerId: authCtx?.customerId,
        orgId: authCtx?.orgId,
        userId: authCtx?.userId,
        selectedToken: tokenCtx?.selectedToken,
        totalTokens,
        totalPrice: getDiscountedAmount()
      }
    });
  };


  useEffect(() => {
    if (isBack && tokenCtx?.tokenCount >= 0) {
      const str = tokenCtx?.tokenCount.toString().padStart(3, '0').split('').map(Number);
      setTokenValue(str)
    }
  }, [isBack])

  const token = localStorage.getItem('token')

  useEffect(() => {
    const fetchCards = async () => {
      setIsLoading(true);
      try {
        const savedCards = await fetchSavedCards(authCtx?.customerId, token);

        console.log("card data", savedCards);

        if (savedCards.length > 0) {
          const card = savedCards[0].card;

          setCardInfo({
            cardNumber: `xxxx xxxx xxxx ${card.last4}`,
            expMonth: card.exp_month.toString().padStart(2, "0"),
            expYear: card.exp_year.toString().slice(-2),
            cvv: "***",
          });

          setUseSavedCard({ cardNumber: true, expiry: true, cvv: true });
          setHasSavedCard(true);
          tokenCtx.setRefreshCards(false)
        }
        else {
          console.log("No cards found, setting hasSavedCard to false", savedCards);
          setHasSavedCard(false);
        }
      } catch (error) {
        console.error("Error fetching saved cards:", error);
        setHasSavedCard(false);
      } finally {
        setIsLoading(false);
      }
    };

    if (authCtx?.customerId && token) {
      fetchCards();
    }
  }, [authCtx?.customerId, token, tokenCtx.refreshCards]);




  return (
    <div className="token-table-container">
      {
        isLoading ? (
          <div
            className="loading-container"
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}
          >
            <CircularProgress />
          </div>
        ) :
          <>
            <div className="tab-container">
              <div className={`tab ${activeTab === "Buy Tokens" ? "active" : ""}`} onClick={() => setActiveTab("Buy Tokens")} >
                Buy Tokens
              </div>
              <div className={`tab ${activeTab === "Purchase History" ? "active" : ""}`} onClick={() => setActiveTab("Purchase History")} >
                Purchase History
              </div>
              <div className={`tab ${activeTab === "Payment Method" ? "active" : ""}`} onClick={() => setActiveTab("Payment Method")} >
                Payment Method
              </div>
            </div>

            {activeTab === "Buy Tokens" ? (<>
              {heading}
              <div className="token-table">
                <div className="token-body">
                  <h3>How many tokens would you like to buy?</h3>
                  <div className="token-row">
                    <div className="inner-container">
                      <div className="token-box" onClick={startEditing} style={{ cursor: 'pointer' }}>
                        {isEditing ? (
                          <input
                            type="text"
                            value={directInput}
                            onChange={handleDirectInputChange}
                            onBlur={handleInputSubmit}
                            onKeyPress={handleKeyPress}
                            autoFocus
                            style={{
                              width: '100%',
                              border: 'none',
                              textAlign: 'center',
                              fontSize: 'inherit',
                              padding: '8px 0',
                              outline: 'none',
                              background: 'transparent'
                            }}
                          />
                        ) : (
                          <>
                            <div className="digit">{tokenValue[0]}</div>
                            <div className="divider"></div>
                            <div className="digit">{tokenValue[1]}</div>
                            <div className="divider"></div>
                            <div className="digit">{tokenValue[2]}</div>
                          </>
                        )}
                      </div>
                      <div className="token-icon">
                        <img src={plus} alt="plus Icon" className="plus" onClick={increment} />
                        <img src={minus} alt="minus Icon" className="plus" onClick={decrement} />
                        <div className="add-tokens-info">
                          <p className="info-line">Type or tap +/- to add tokens</p>
                        </div>
                      </div>
                    </div>
                    <div className="price-box">
                      <div className="first-box">
                        <p className="text-token">Tokens</p>
                        <div className="token-inner-box">
                          <img src={CoinIcon} alt="Coin Icon" className="coin-icon" />
                          <p style={{ fontSize: "24px", width: "18px" }}>X</p>
                          <p style={{ fontSize: "24px" }}>{totalTokens}</p>
                        </div>
                      </div>

                      <div className="second-box">
                        <p className="text-token">Price</p>
                        <div className="second-inner-box">
                          <img
                            src={CoinIcon}
                            alt="Coin Icon"
                            className="second-coin-icon"
                          />
                          <p className="second-text-token">1 token = ${pricePerToken}</p>
                        </div>
                      </div>

                      <div className="third-box">
                        <p className="text-token">Total</p>
                        <p className="third-text-token">${getDiscountedAmount()}</p>
                      </div>
                    </div>
                    <button className="buy-button" onClick={handleCheckoutClick}>
                      <p className="button-text">Proceed to Buy {totalTokens} Tokens</p>
                    </button>
                  </div>

                  <div className="line-with-text">
                    <p className="line-text">Save more on tokens</p>
                  </div>
                  <div className="token-info-container">

                    <div className="last-test">
                      <span>Buy between</span>
                      <span>Price per token</span>
                      <span>Save up to</span>
                    </div>
                    <div className="last-box">
                      <p className="range">21-50</p>
                      <p className="price">
                        <img src={CoinIcon} alt="Coin Icon" className="coin-icon" /> 1
                        token = $45
                      </p>
                      <p className="save">$250</p>
                    </div>
                    <div className="last-box">
                      <p className="range"> 51-100 </p>
                      <p className="price">
                        <img src={CoinIcon} alt="Coin Icon" className="coin-icon" /> 1
                        token = $40
                      </p>
                      <p className="save">$1000</p>
                    </div>
                  </div>
                </div>
                <div className="second-token-container">
                  <div className="wallet-section">
                    <div className="wallet-text">Wallet</div>
                    <div className="first-container">
                      <img src={CoinIcon} alt="Coin Icon" width={"22px"} height={"22px"} />
                      <div className="inner-box">You have {tokenCtx.selectedToken} tokens</div>
                    </div>
                  </div>
                  <div className="second-container">
                    <div className="cost-sheet-container">
                      <p className="cost-sheet">Pricing</p>
                      <div className="inner-cost-sheet">
                        <div className="inner-first">
                          <p className="text">Self - Assessment</p>
                          <div className="token-info">
                            <img src={CoinIcon} alt="Coin Icon" className="img-icon" />
                            <p className="small-text">2 Tokens</p>
                          </div>
                        </div>
                        <div className="inner-first">
                          <p className="text">360 Assessment</p>
                          <div className="token-info">
                            <img src={CoinIcon} alt="Coin Icon" className="img-icon" />
                            <p className="small-text">4 Tokens</p>
                          </div>
                        </div>
                        <div className="inner-first">
                          <p className="text">Group Report</p>
                          <div className="token-info">
                            <img src={CoinIcon} alt="Coin Icon" className="img-icon" />
                            <p className="small-text">4 Tokens</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Disclaimer />
                </div>
              </div>
            </>
            ) : activeTab === "Purchase History" ? (
              <PurchaseHistory switchToBuyTab={() => setActiveTab("Buy Tokens")} />
            ) :
              <AddNewCard switchToBuyTab={() => setActiveTab("Buy Tokens")} totalTokens={totalTokens} />
            }
          </>
      }
    </div>
  );
}
